import React, { useEffect } from 'react';
import AuthService from '../services/authService';
import Spinners from '../components/spinner';

const CookieClearPage = () => {
  const authService = new AuthService();

  useEffect(() => {
    authService
      .logout()
      .then(() => {})
      .catch(() => {});
    sessionStorage.clear();
    localStorage.clear();
  }, []);

  return <Spinners containerClassName='h-normal-screen' />;
};

export default CookieClearPage;
